import type { ErrorCopy } from '@shared/errors/catalog';

import { financeErrors } from '../_shared/errors';

/**
 * The codes this surface meets. Every one of them is already in the service's
 * own catalogue — the registry raises nothing this feature owns alone — so the
 * map is the shared one, named here so the surface reads from a catalogue rather
 * than from a spread at a call site.
 *
 * The two that matter most on this route are the activation refusal
 * (`FINANCE_GATEWAY_NOT_CONFIGURED`) and the delete refusal
 * (`FINANCE_GATEWAY_ACTIVE_CANNOT_DELETE`): both name the remedy the operator
 * can take, and both are also stated in the row menu's hint before the request
 * is ever made.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = financeErrors;
